/* unplugin-vue-components disabled */import { ElButton as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import __unplugin_components_0 from '/Users/zpw/Documents/hero/ultrasdk.hub.web/packages/base/src/components/GameChannelSelect/index.vue';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex justify-end"
};
const _hoisted_2 = /*#__PURE__*/_createTextVNode("批量修改");
const _hoisted_3 = /*#__PURE__*/_createTextVNode("修改");
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import { apiUsdkGetRealNameProductList } from '@/api/usdk';
import AddOrEditChannelRealName from './addOrEditChannelRealName.vue';
export default /*#__PURE__*/_defineComponent({
  props: {
    gameInfo: {
      type: Object
    }
  },
  setup(__props) {
    const props = __props;
    const filter = ref({
      cids: ''
    });
    const multipleSelection = ref([]);
    const addOrEditChannelRealNameRef = ref();
    const columns = [{
      label: '联运渠道',
      prop: 'channelName'
    }, {
      label: '登录/支付实名',
      prop: 'login',
      slot: 'login'
    }, {
      label: '需要填写手机号',
      prop: 'needPhone',
      slot: 'needPhone'
    }, {
      label: '验证实名',
      prop: 'isRealIcValidate',
      slot: 'isRealIcValidate'
    }, {
      label: '未成年限制',
      prop: 'minorsLogin',
      slot: 'minorsLogin'
    }, {
      label: '操作',
      action: true
    }];
    const getTableData = () => {
      tableLoading.value = true;
      apiUsdkGetRealNameProductList({
        gid: props.gameInfo && props.gameInfo.Id,
        ...filter.value
      }).then(res => {
        if (res.code === 0) {
          tableData.value = res.data;
        }
        tableLoading.value = false;
      });
    };
    const {
      tableData,
      tableLoading,
      current,
      pageSize,
      total,
      handleSizeChange,
      handleCurrentChange
    } = UseTable(getTableData);
    const handleMultipleSelect = select => {
      multipleSelection.value = select;
    };
    const handleClick = (type, data) => {
      if (type === 'edit') {
        addOrEditChannelRealNameRef.value.show({
          type,
          data,
          gameInfo: props.gameInfo,
          multipleSelection: multipleSelection.value
        });
      } else {
        addOrEditChannelRealNameRef.value.show({
          type,
          gameInfo: props.gameInfo,
          multipleSelection: multipleSelection.value
        });
      }
    };
    watch(() => props.gameInfo, val => {
      if (val && val.Id) {
        getTableData();
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_game_channel_select = __unplugin_components_0;
      const _component_el_form_item = __unplugin_components_1;
      const _component_el_button = __unplugin_components_2;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form_item, {
        label: "渠道"
      }, {
        default: _withCtx(() => [_createVNode(_component_game_channel_select, {
          modelValue: filter.value.cids,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => filter.value.cids = $event),
          clearable: "",
          gid: __props.gameInfo && __props.gameInfo.Id,
          onChange: getTableData,
          otherProps: {
            needIos: 1,
            isHero: 1
          }
        }, null, 8, ["modelValue", "gid"])]),
        _: 1
      }), _createVNode(_component_el_button, {
        class: "marginL20",
        type: "primary",
        onClick: _cache[1] || (_cache[1] = $event => handleClick('batchEdit')),
        disabled: multipleSelection.value.length === 0
      }, {
        default: _withCtx(() => [_hoisted_2]),
        _: 1
      }, 8, ["disabled"])]), _createVNode(UTable, {
        options: columns,
        data: _unref(tableData),
        loading: _unref(tableLoading),
        pagination: "",
        isMultiple: "",
        "current-page": _unref(current),
        "page-size": _unref(pageSize),
        total: _unref(total),
        onSizeChange: _unref(handleSizeChange),
        onCurrentChange: _unref(handleCurrentChange),
        onMultipleSelect: handleMultipleSelect
      }, {
        login: _withCtx(({
          scope
        }) => [_createTextVNode(_toDisplayString(scope.row.login == 0 ? '不实名' : scope.row.login == 1 ? '可选实名' : scope.row.login == 2 ? '强制实名' : ''), 1)]),
        needPhone: _withCtx(({
          scope
        }) => [_createTextVNode(_toDisplayString(scope.row.needPhone ? '是' : '否'), 1)]),
        isRealIcValidate: _withCtx(({
          scope
        }) => [_createTextVNode(_toDisplayString(scope.row.isRealIcValidate ? '真实验证' : '非真实验证'), 1)]),
        minorsLogin: _withCtx(({
          scope
        }) => [_createTextVNode(_toDisplayString(scope.row.minorsLogin ? '允许' : '不允许'), 1)]),
        action: _withCtx(({
          scope
        }) => [_createVNode(_component_el_button, {
          link: "",
          type: "primary",
          onClick: $event => handleClick('edit', scope.row)
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      }, 8, ["data", "loading", "current-page", "page-size", "total", "onSizeChange", "onCurrentChange"]), _createVNode(AddOrEditChannelRealName, {
        ref_key: "addOrEditChannelRealNameRef",
        ref: addOrEditChannelRealNameRef,
        onSuccess: getTableData
      }, null, 512)], 64);
    };
  }
});